import { isNil } from 'lodash';
import { CSSProperties, useMemo, VoidFunctionComponent } from 'react';
import { Placeholder } from 'components/elements';
import { StyledTableCell } from './TableCell.styled';
import { TablePlaceholderCellProps } from './types';

export const TablePlaceholderCell: VoidFunctionComponent<TablePlaceholderCellProps> = props => {
  const { column } = props;

  // Build cell style object
  const style = useMemo<CSSProperties>(
    () => ({
      width: !isNil(column.width) ? `${column.width}px` : undefined,
    }),
    [column.width],
  );

  return (
    <StyledTableCell $align={column.align ?? 'left'} style={style}>
      <Placeholder width={70} />
    </StyledTableCell>
  );
};
